import React from 'react';
import { BrowserQRCodeReader, Result } from '@zxing/library';
import {
    makeStyles,
    Dialog,
    // Slide,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flexGrow: 1,
    },
    content: {
        flexGrow: 1,
        margin: 0,
        top: 'auto',
        bottom: 0,
        position: 'fixed',
        // background: '#445566',
    }
}));

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });
type Props = {
    onResult: (text: string) => void,
    onError: (errorMsg: string) => void,
    onCancel: () => void
}
const ZxingReader: React.FC<Props> = (props) => {
    const classes = useStyles();
    const codeReader = new BrowserQRCodeReader(500);
    codeReader.decodeFromInputVideoDevice(undefined, 'video').then((result: Result) => {
        console.log(result);
        props.onResult(result.getText());
    }).catch((err) => {
        console.error(err);
        props.onError('не удалось распознать QR-код');
    })
    return (
        <div>
            <Dialog fullScreen open={true} >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit"
                            onClick={() => props.onCancel()}>
                            <CloseIcon />
                        </IconButton>
                        <Typography className={classes.title}>Сканирование QR</Typography>
                    </Toolbar>
                </AppBar>
                <video className={classes.content} id="video" />
            </Dialog>
        </div >
    );


}

export default ZxingReader; 